/* eslint-disable no-shadow,no-unused-vars,camelcase,no-param-reassign */
/* eslin-disable no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import modules from '@/store/shared/index.js';
import RECORD_MUTATIONS from '@/store/lib/mutations';

Vue.use(Vuex);

const store = new Vuex.Store({
  mutations: {
    ...RECORD_MUTATIONS,
  },

  modules: {
    shared: {
      ...modules
    },
  },
});

export default store;
